import Cookies from 'universal-cookie';
import {refreshTokenApi, validateTokenApi} from '../../services/auth-api';
import {clearCookiesStorageAndRedirect} from '../utility/utility';

const cookies = new Cookies();
const cookiesToken = cookies.get('token');
export const token = cookiesToken ? cookiesToken.token : null;

export const validateToken = async () => {
    const cookieToken = cookies.get('token');
    if (cookieToken !== null && cookieToken !== undefined && cookieToken !== "") {
      await validateTokenApi(cookieToken.token)
        .then(response => {
          const obj = response;
          if (obj && obj.isError === false && obj.isActive === true) {
            refreshToken();
          }
        })
        .catch(error => {
          clearCookiesStorageAndRedirect(false);
        })
    } else {
      clearCookiesStorageAndRedirect(false);
    }
}

export const refreshToken = async () => {
    const cookieToken = cookies.get('token');
    if (cookieToken !== null && cookieToken !== undefined && cookieToken !== "") {
        const refreshTokenValue = localStorage.getItem('rftValue');
        
        if ((cookieToken.refreshToken !== null && cookieToken.refreshToken !== undefined 
                && cookieToken.refreshToken !== "") || (refreshTokenValue !== null && refreshTokenValue !== undefined 
                    && refreshTokenValue !== "") ) { 

                const refreshTokenVal = cookieToken.refreshToken ? cookieToken.refreshToken : refreshTokenValue;   
                // storing refreshToken in session if we get null value in next call
                localStorage.setItem('rftValue', refreshTokenVal);

                await refreshTokenApi(cookieToken.token, refreshTokenVal)
                .then(response => {
                    const obj = response;
                    if (obj && !obj.error) {
                    cookies.remove('token', { path: '/' });
                    cookies.set("token", obj, { path: '/', maxAge: obj.expiresIn });
                    }
                })
                .catch(error => {
                  clearCookiesStorageAndRedirect(false);
                })
        } else {
          clearCookiesStorageAndRedirect(false);
        }
    } else {
      clearCookiesStorageAndRedirect(false);
    }
}